import styled from 'styled-components';

import { Title } from '../shared-styles';

export const BanModalTitle = styled(Title)`
  display: flex;
  align-items: baseline;
  color: #f6335d;
`;
